import { render, staticRenderFns } from "./PerformanceHeaderToolbar.vue?vue&type=template&id=3d492680&scoped=true&"
import script from "./PerformanceHeaderToolbar.vue?vue&type=script&lang=js&"
export * from "./PerformanceHeaderToolbar.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceHeaderToolbar.vue?vue&type=style&index=0&id=3d492680&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d492680",
  null
  
)

export default component.exports